import {type RouteLocationStringParam, type RouteRecordRaw} from 'vue-router';
import {addSessionserviceRoutes} from './sessionservice';

const SessionserviceCouncilGroupTypeList = () => import('../../views/sessionservice/council/group/SessionserviceCouncilGroupTypeList.vue');

const SessionserviceCouncilCommissionList     = () => import('../../views/sessionservice/council/commission/SessionserviceCouncilCommissionList.vue');
const SessionserviceCouncilCommissionTypeList = () => import('../../views/sessionservice/council/commission/SessionserviceCouncilCommissionTypeList.vue');
const SessionserviceCouncilCommissionEdit     = () => import('../../views/sessionservice/council/commission/SessionserviceCouncilCommissionEdit.vue');

const SessionserviceCouncilParliamentaryList = () => import('../../views/sessionservice/council/parliamentary/SessionserviceCouncilParliamentaryList.vue');
const SessionserviceCouncilParliamentaryView = () => import('../../views/sessionservice/council/parliamentary/SessionserviceCouncilParliamentaryView.vue');
const SessionserviceCouncilParliamentaryEdit = () => import('../../views/sessionservice/council/parliamentary/SessionserviceCouncilParliamentaryEdit.vue');

const SessionserviceCouncilPublicationList     = () => import('../../views/sessionservice/council/publication/SessionserviceCouncilPublicationList.vue');
const SessionserviceCouncilPublicationEdit     = () => import('../../views/sessionservice/council/publication/SessionserviceCouncilPublicationEdit.vue');
const SessionserviceCouncilPublicationSettings = () => import('../../views/sessionservice/council/publication/SessionserviceCouncilPublicationSettings.vue');

const SessionserviceCouncilLegalFrameworkList     = () => import('../../views/sessionservice/council/legal-framework/SessionserviceCouncilLegalFrameworkList.vue');
const SessionserviceCouncilLegalFrameworkView     = () => import('../../views/sessionservice/council/legal-framework/SessionserviceCouncilLegalFrameworkView.vue');
const SessionserviceCouncilLegalFrameworkEdit     = () => import('../../views/sessionservice/council/legal-framework/SessionserviceCouncilLegalFrameworkEdit.vue');
const SessionserviceCouncilLegalFrameworkSettings = () => import('../../views/sessionservice/council/legal-framework/SessionserviceCouncilLegalFrameworkSettings.vue');
const SessionserviceCouncilLegalFrameworkSort     = () => import('../../views/sessionservice/council/legal-framework/SessionserviceCouncilLegalFrameworkSort.vue');

const SessionserviceCouncilGeoscopeList = () => import('../../views/sessionservice/council/geoscope/SessionserviceCouncilGeoscopeList.vue');

const resource     = 'councilservice';
let meta: MetaData = {
    module: resource,
};

let routes: RouteRecordRaw[] = [];

let groupTypes = 'municipalityRepresentation|caucus|localCouncil|districtAssembly|caucusDistrictAssembly|municipalityAssociationbly|caucusMunicipalityAssociationbly'
    + '|municipality-representation|local-council|district-assembly|caucus-district-assembly|municipality-associationbly|caucus-municipality-associationbly'
    + '|municipalityrepresentation|localcouncil|districtassembly|caucusdistrictassembly|municipalityassociationbly|caucusmunicipalityassociationbly';

let commissionTypes = 'head|mayor|ortsbuergermeister|localMayor|localChief'
    + '|local-mayor|local-chief'
    + '|localmayor|localchief';

//<editor-fold desc="Group">
routes.push(
    // old compatibility route
    {
        path: '/' + resource + '/group/:type(' + groupTypes + ')/title/:title?',
        alias: '/' + resource + '/group/:type(' + groupTypes + ')/title/:title?/:wildcard*',
        redirect: {name: resource + '-group-type-list'},
        meta,
    },
    {
        name: resource + '-group-type-list',
        path: '/' + resource + '/group/:type(' + groupTypes + ')/:title?',
        meta,
        component: SessionserviceCouncilGroupTypeList,
        props(route: RouteLocationStringParam)
        {
            return {
                resource,
                type: route.params.type,
                title: route.params.title,
            };
        },
    },
);
//</editor-fold>

//<editor-fold desc="Commission">
routes.push(
    // old compatibility route
    {
        path: '/' + resource + '/commission/:type(' + commissionTypes + ')/title/:title?',
        alias: '/' + resource + '/commission/:type(' + commissionTypes + ')/title/:title?/:wildcard*',
        redirect: {name: resource + '-commission-type-list'},
        meta,
    },
    {
        name: resource + '-commission-type-list',
        path: '/' + resource + '/commission/:type(' + commissionTypes + ')/:title?',
        meta,
        component: SessionserviceCouncilCommissionTypeList,
        props(route: RouteLocationStringParam)
        {
            return {
                resource,
                type: route.params.type,
                title: route.params.title,
            };
        },
    },
    {
        name: resource + '-commission-list',
        path: '/' + resource + '/commission/list',
        meta,
        component: SessionserviceCouncilCommissionList,
        props()
        {
            return {
                resource,
            };
        },
    },
    {
        name: resource + '-commission-add',
        path: '/' + resource + '/commission/add',
        meta,
        component: SessionserviceCouncilCommissionEdit,
        props()
        {
            return {
                resource,
            };
        },
    },
    {
        name: resource + '-commission-edit',
        path: '/' + resource + '/commission/edit/:id',
        meta,
        component: SessionserviceCouncilCommissionEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                resource,
                id: parseInt(route.params.id),
            };
        },
    },
    {
        path: '/' + resource + '/commission/:wildcard*',
        redirect: {name: resource + '-commission-list'},
    },
);
//</editor-fold>

//<editor-fold desc="Parliamentary">
routes.push(
    {
        name: resource + '-faction-list',
        path: '/' + resource + '/faction/list',
        meta,
        component: SessionserviceCouncilParliamentaryList,
        props()
        {
            return {
                resource,
                type: 'faction',
            };
        },
    },
    {
        name: resource + '-faction-view',
        path: '/' + resource + '/faction/view/:id',
        alias: '/' + resource + '/faction/view/id/:id',
        meta,
        component: SessionserviceCouncilParliamentaryView,
        props(route: RouteLocationStringParam)
        {
            return {
                resource,
                type: 'faction',
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: resource + '-faction-add',
        path: '/' + resource + '/faction/add',
        meta,
        component: SessionserviceCouncilParliamentaryEdit,
        props()
        {
            return {
                resource,
                type: 'faction',
                id: 0,
            };
        },
    },
    {
        name: resource + '-faction-edit',
        path: '/' + resource + '/faction/edit/:id',
        meta,
        component: SessionserviceCouncilParliamentaryEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                resource,
                type: 'faction',
                id: parseInt(route.params.id),
            };
        },
    },
    {
        path: '/' + resource + '/faction/:wildcard*',
        redirect: {name: resource + '-faction-list'},
    },
    {
        name: resource + '-party-list',
        path: '/' + resource + '/party/list',
        meta,
        component: SessionserviceCouncilParliamentaryList,
        props()
        {
            return {
                resource,
            };
        },
    },
    {
        name: resource + '-party-view',
        path: '/' + resource + '/party/view/:id',
        alias: '/' + resource + '/party/view/id/:id',
        meta,
        component: SessionserviceCouncilParliamentaryView,
        props(route: RouteLocationStringParam)
        {
            return {
                resource,
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: resource + '-party-add',
        path: '/' + resource + '/party/add',
        meta,
        component: SessionserviceCouncilParliamentaryEdit,
        props()
        {
            return {
                resource,
                type: 'party',
                id: 0,
            };
        },
    },
    {
        name: resource + '-party-edit',
        path: '/' + resource + '/party/edit/:id',
        meta,
        component: SessionserviceCouncilParliamentaryEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                resource,
                id: parseInt(route.params.id),
            };
        },
    },
    {
        path: '/' + resource + '/party/:wildcard*',
        redirect: {name: resource + '-party-list'},
    },
);
//</editor-fold>

//<editor-fold desc="Publication">
routes.push(
    {
        name: resource + '-announcement-list',
        path: '/' + resource + '/announcement/list',
        meta,
        component: SessionserviceCouncilPublicationList,
        props()
        {
            return {
                resource,
                type: 'announcement',
            };
        },
    },
    {
        name: resource + '-announcement-add',
        path: '/' + resource + '/announcement/add',
        meta,
        component: SessionserviceCouncilPublicationEdit,
        props()
        {
            return {
                resource,
                type: 'announcement',
                id: 0,
            };
        },
    },
    {
        name: resource + '-announcement-edit',
        path: '/' + resource + '/announcement/edit/:id',
        meta,
        component: SessionserviceCouncilPublicationEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                resource,
                type: 'announcement',
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: resource + '-announcement-settings',
        path: '/' + resource + '/announcement/settings',
        meta,
        component: SessionserviceCouncilPublicationSettings,
        props(route: RouteLocationStringParam)
        {
            return {
                resource,
                type: 'announcement',
                id: parseInt(route.params.id),
            };
        },
    },
    {
        path: '/' + resource + '/announcement/:wildcard*',
        redirect: {name: resource + '-announcement-list'},
    },
    {
        name: resource + '-gazette-list',
        path: '/' + resource + '/gazette/list',
        meta,
        component: SessionserviceCouncilPublicationList,
        props()
        {
            return {
                resource,
            };
        },
    },
    {
        name: resource + '-gazette-add',
        path: '/' + resource + '/gazette/add',
        meta,
        component: SessionserviceCouncilPublicationEdit,
        props()
        {
            return {
                resource,
                type: 'gazette',
                id: 0,
            };
        },
    },
    {
        name: resource + '-gazette-edit',
        path: '/' + resource + '/gazette/edit/:id',
        meta,
        component: SessionserviceCouncilPublicationEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                resource,
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: resource + '-gazette-settings',
        path: '/' + resource + '/gazette/settings',
        meta,
        component: SessionserviceCouncilPublicationSettings,
        props()
        {
            return {
                resource,
            };
        },
    },
    {
        path: '/' + resource + '/gazette/:wildcard*',
        redirect: {name: resource + '-gazette-list'},
    },
);
//</editor-fold>

//<editor-fold desc="Legal Framework">
routes.push(
    // old compatibility route
    {
        path: '/' + resource + '/legal-framework/list/type/:type/layer/:layer/:wildcard*',
        redirect: {name: resource + '-legal-framework-list'},
        meta,
    },
    // old compatibility route
    {
        path: '/' + resource + '/legal-framework/list/type/:type/:wildcard*',
        redirect: {name: resource + '-legal-framework-list'},
        meta,
    },
    {
        name: resource + '-legal-framework-list',
        path: '/' + resource + '/legal-framework/list/:type?/:layer?',
        alias: '/' + resource + '/legal-framework/list/type/:type?/layer/:layer?',
        meta,
        component: SessionserviceCouncilLegalFrameworkList,
        props(route: RouteLocationStringParam)
        {
            return {
                resource,
                type: parseInt(route.params.type) || 0,
                layer: 'undefined' === typeof route.params.layer || route.params.layer === '' ? null : parseInt(route.params.layer),
            };
        },
    },
    {
        name: resource + '-legal-framework-add',
        path: '/' + resource + '/legal-framework/add',
        meta,
        component: SessionserviceCouncilLegalFrameworkEdit,
        props()
        {
            return {
                resource,
            };
        },
    },
    {
        name: resource + '-legal-framework-edit',
        path: '/' + resource + '/legal-framework/edit/:id',
        meta,
        component: SessionserviceCouncilLegalFrameworkEdit,
        props(route: RouteLocationStringParam)
        {
            return {
                resource,
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: resource + '-legal-framework-view',
        path: '/' + resource + '/legal-framework/view/:id',
        meta,
        component: SessionserviceCouncilLegalFrameworkView,
        props(route: RouteLocationStringParam)
        {
            return {
                resource,
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: resource + '-legal-framework-settings',
        path: '/' + resource + '/legal-framework/settings',
        meta,
        component: SessionserviceCouncilLegalFrameworkSettings,
        props(route: RouteLocationStringParam)
        {
            return {
                resource,
                id: parseInt(route.params.id),
            };
        },
    },
    {
        name: resource + '-legal-framework-sort',
        path: '/' + resource + '/legal-framework/sort/:geoscope?/:type?',
        meta,
        component: SessionserviceCouncilLegalFrameworkSort,
        props(route: RouteLocationStringParam)
        {
            return {
                resource,
                preselectGeoscope: parseInt(route.params.geoscope),
                preselectType: parseInt(route.params.type),
            };
        },
    },
    {
        path: '/' + resource + '/legal-framework/:wildcard*',
        redirect: {name: resource + '-legal-framework-list'},
    },
);
//</editor-fold>

//<editor-fold desc="Geoscope">
routes.push(
    {
        name: resource + '-geoscope-list',
        path: '/' + resource + '/geoscope/list',
        meta,
        component: SessionserviceCouncilGeoscopeList,
        props()
        {
            return {
                resource,
            };
        },
    },
    {
        path: '/' + resource + '/geoscope/:wildcard*',
        redirect: {name: resource + '-geoscope-list'},
    },
);
//</editor-fold>

addSessionserviceRoutes(routes, resource, meta);

export default routes;
